import React from "react";
import AddContractImage from "../../../assets/AddContract.png";

function NoDocument() {
  return (
    <div
      style={{
        height: "100%",
        display: "grid",
        placeContent: "center",
        placeItems: "center",
      }}
    >
      <img src={AddContractImage} alt="Add Contract" style={{ width: "75px", height: "75px" }} />
      <p
        style={{
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "700",
          marginBottom: "10px",
          color: "#424165",
        }}
      >
        Please open a document to start the AI analysis
      </p>
    </div>
  );
}

export default NoDocument;
